module.exports = __webpack_public_path__ + "assets/affbe62c3da56d9e991b90af45ed7237.mp3";